/* eslint-disable radix */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-curly-brace-presence */

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import {
  Button,
  Input,
  InputNumber,
  Loader,
  IconButton,
} from 'rsuite';
import {
  MdArrowBack,
  MdSave,
  MdAdd,
  MdDelete,
  MdDragIndicator,
  MdQuiz,
  MdSettings,
} from 'react-icons/md';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import {
  PageContainer,
  MainContent,
  PageHeader,
  Section,
  FormGroup,
  QuestionCard,
  EmptyState,
} from './styles';
import QuestionSelector from './components/QuestionSelector';
import QuestionEditor from './components/QuestionEditor';
import ConfirmDialog from './components/ConfirmDialog';
import SortableList from './components/SortableList';
import {
  getModuloById,
  updateModulo,
  getQuestoesQuiz,
  addQuestoesQuizBulk,
  removeQuestaoQuiz,
  reorderQuestoesQuiz,
  createQuestao,
} from '../../services/treinamentos';

function EditorModuloQuiz({showEditorModulos, setShowEditorModulos, idTreinamentoModulos,idModulo, setShowModulos}) {
  // const { id: treinamentoId, moduloId } = useParams();
  const treinamentoId = idTreinamentoModulos;
  const moduloId = idModulo;
  const history = useHistory();

  // Estado geral
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [_modulo, setModulo] = useState(null);
  const [treinamento, setTreinamento] = useState(null);

  // Dados do módulo
  const [tituloModulo, setTituloModulo] = useState('');
  const [notaMinima, setNotaMinima] = useState(70);
  const [hasChanges, setHasChanges] = useState(false);

  // Questões do quiz
  const [questoes, setQuestoes] = useState([]);
  const [loadingQuestoes, setLoadingQuestoes] = useState(false);

  // Modais
  const [questionSelectorOpen, setQuestionSelectorOpen] = useState(false);
  const [questionEditorOpen, setQuestionEditorOpen] = useState(false);
  const [deleteQuestionModal, setDeleteQuestionModal] = useState({ open: false, id: null, enunciado: '' });
  const [deletingQuestion, setDeletingQuestion] = useState(false);
  const [savingQuestion, setSavingQuestion] = useState(false);

  // Carregar módulo
  const loadModulo = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getModuloById(moduloId);
      setModulo(data);
      setTituloModulo(data.titulo || '');
      setNotaMinima(data.nota_minima_aprovacao || 70);
      setTreinamento(data.treinamento);
    } catch (error) {
      toast.error('Erro ao carregar módulo');
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [moduloId]);

  // Carregar questões
  const loadQuestoes = useCallback(async () => {
    setLoadingQuestoes(true);
    try {
      const data = await getQuestoesQuiz(moduloId);
      setQuestoes(data || []);
    } catch (error) {
      console.error('Erro ao carregar questões:', error);
    } finally {
      setLoadingQuestoes(false);
    }
  }, [moduloId]);

  useEffect(() => {
    loadModulo();
    loadQuestoes();
  }, [loadModulo, loadQuestoes]);

  // Salvar módulo
  const handleSave = useCallback(async () => {
    if (!tituloModulo.trim()) {
      toast.error('O título é obrigatório');
      return;
    }

    setSaving(true);
    try {
      await updateModulo(moduloId, {
        titulo: tituloModulo,
        nota_minima_aprovacao: notaMinima,
      });
      toast.success('Módulo salvo com sucesso!');
      setHasChanges(false);
    } catch {
      toast.error('Erro ao salvar módulo');
    } finally {
      setSaving(false);
    }
  }, [moduloId, tituloModulo, notaMinima]);

  // Selecionar questões do banco
  const handleSelectQuestions = useCallback(async (selectedQuestoes) => {
    try {
      const ids = selectedQuestoes.map((q) => q.id);
      await addQuestoesQuizBulk(moduloId, ids);
      loadQuestoes();
      toast.success(`${ids.length} questão(ões) adicionada(s)`);
    } catch {
      toast.error('Erro ao adicionar questões');
    }
  }, [moduloId, loadQuestoes]);

  // Criar nova questão
  const handleCreateQuestion = useCallback(async (data) => {
    setSavingQuestion(true);
    try {
      const questao = await createQuestao(data);
      
      // Adicionar ao quiz
      await addQuestoesQuizBulk(moduloId, [questao.id]);
      
      setQuestionEditorOpen(false);
      setQuestionSelectorOpen(false);
      loadQuestoes();
      toast.success('Questão criada e adicionada!');
    } catch {
      toast.error('Erro ao criar questão');
    } finally {
      setSavingQuestion(false);
    }
  }, [moduloId, loadQuestoes]);

  // Remover questão
  const handleRemoveQuestion = useCallback(async () => {
    if (!deleteQuestionModal.id) return;

    setDeletingQuestion(true);
    try {
      await removeQuestaoQuiz(moduloId, deleteQuestionModal.id);
      toast.success('Questão removida do quiz');
      setDeleteQuestionModal({ open: false, id: null, enunciado: '' });
      loadQuestoes();
    } catch {
      toast.error('Erro ao remover questão');
    } finally {
      setDeletingQuestion(false);
    }
  }, [moduloId, deleteQuestionModal.id, loadQuestoes]);

  // Reordenar questões
  const handleReorderQuestoes = useCallback(async (newQuestoes) => {
    setQuestoes(newQuestoes);
    try {
      const questoesOrdem = newQuestoes.map((q, index) => ({
        id_questao: q.questao?.id || q.id_questao,
        ordem: index + 1,
      }));
      await reorderQuestoesQuiz(moduloId, questoesOrdem);
    } catch {
      toast.error('Erro ao reordenar questões');
      loadQuestoes();
    }
  }, [moduloId, loadQuestoes]);

  // IDs das questões já adicionadas
  const existingQuestionIds = questoes.map((q) => q.questao?.id || q.id_questao);

  if (loading) {
    return (
      <PageContainer>
        <MainContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Loader size="lg" content="Carregando..." />
        </MainContent>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <MainContent>
        <PageHeader>
          <div
            className="back-button"
            onClick={() => setShowEditorModulos(false)}
          >
            <MdArrowBack />
            Voltar
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              appearance="primary"
              onClick={handleSave}
              loading={saving}
              disabled={!hasChanges}
            >
              <MdSave style={{ marginRight: 8 }} />
              Salvar
            </Button>
          </div>
        </PageHeader>

        <Section>
          <FormGroup>
            <label>Título do Módulo</label>
            <Input
              value={tituloModulo}
              onChange={(v) => {
                setTituloModulo(v);
                setHasChanges(true);
              }}
              placeholder="Título do quiz"
              size="lg"
            />
          </FormGroup>

          <FormGroup>
            <label>Nota mínima para aprovação (%)</label>
            <InputNumber
              value={notaMinima}
              onChange={(v) => {
                setNotaMinima(v);
                setHasChanges(true);
              }}
              min={0}
              max={100}
              style={{ width: 200 }}
            />
          </FormGroup>
        </Section>

        <Section>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h2>Questões do Quiz ({questoes.length})</h2>
            <Button
              appearance="primary"
              onClick={() => setQuestionSelectorOpen(true)}
            >
              <MdAdd style={{ marginRight: 8 }} />
              Adicionar Questões
            </Button>
          </div>

          {loadingQuestoes ? (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <Loader content="Carregando questões..." />
            </div>
          ) : questoes.length === 0 ? (
            <EmptyState>
              <MdQuiz style={{ fontSize: 48 }} />
              <h3>Nenhuma questão</h3>
              <p>Adicione questões do banco para montar o quiz</p>
              <Button
                appearance="primary"
                onClick={() => setQuestionSelectorOpen(true)}
              >
                <MdAdd style={{ marginRight: 8 }} />
                Adicionar Questões
              </Button>
            </EmptyState>
          ) : (
            <SortableList
              items={questoes}
              onReorder={handleReorderQuestoes}
              keyExtractor={(item) => item.id || item.id_questao}
              renderItem={(item, index, isDragging) => {
                const questao = item.questao || item;
                return (
                  <QuestionCard style={{ opacity: isDragging ? 0.5 : 1 }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                      <MdDragIndicator
                        style={{ cursor: 'grab', color: '#999', marginTop: 4 }}
                      />
                      <div style={{ flex: 1 }}>
                        <div className="question-header">
                          {index + 1}. {questao.enunciado}
                        </div>
                        {questao.alternativas && (
                          <div className="alternatives">
                            {questao.alternativas.map((alt) => (
                              <div
                                key={alt.id}
                                className={`alternative ${alt.correta ? 'correct' : ''}`}
                              >
                                {alt.correta ? '✓' : '○'} {alt.texto}
                              </div>
                            ))}
                          </div>
                        )}
                        <div className="question-meta">
                          <span>{questao.alternativas?.length || 0} alternativas</span>
                          <IconButton
                            icon={<MdDelete />}
                            appearance="subtle"
                            color="red"
                            size="sm"
                            onClick={() =>
                              setDeleteQuestionModal({
                                open: true,
                                id: questao.id,
                                enunciado: questao.enunciado,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </QuestionCard>
                );
              }}
            />
          )}
        </Section>
      </MainContent>

      {/* Modal de seleção de questões */}
      <QuestionSelector
        open={questionSelectorOpen}
        onClose={() => setQuestionSelectorOpen(false)}
        onSelect={handleSelectQuestions}
        onCreateNew={() => {
          setQuestionSelectorOpen(false);
          setQuestionEditorOpen(true);
        }}
        multiple
        excludeIds={existingQuestionIds}
        title="Adicionar Questões ao Quiz"
      />

      {/* Modal de criação de questão */}
      <QuestionEditor
        open={questionEditorOpen}
        onClose={() => setQuestionEditorOpen(false)}
        onSave={handleCreateQuestion}
        loading={savingQuestion}
      />

      {/* Modal de confirmação de remoção */}
      <ConfirmDialog
        open={deleteQuestionModal.open}
        onClose={() => setDeleteQuestionModal({ open: false, id: null, enunciado: '' })}
        onConfirm={handleRemoveQuestion}
        title="Remover Questão"
        message={`Tem certeza que deseja remover esta questão do quiz? A questão continuará disponível no banco de questões.`}
        confirmText="Remover"
        loading={deletingQuestion}
      />
    </PageContainer>
  );
}

EditorModuloQuiz.propTypes = {
  showEditorModulos: PropTypes.bool.isRequired,
  setShowEditorModulos: PropTypes.func.isRequired,
  idModulo: PropTypes.number.isRequired,
  idTreinamentoModulos: PropTypes.number.isRequired,
  setShowModulos: PropTypes.func.isRequired,
};

export default EditorModuloQuiz;
